import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { EditorState, ContentState, convertToRaw, Modifier } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html'
import { BlockPicker } from 'react-color';
import api from '../../services/api';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';


function ColorOption(props) {
  const { onChange } = props;


  const onChangeModal = (color) => {
    onChange('bgcolor', color.hex);
  }

  const renderModal = () => {
    const { bgColor } = props.currentState;
    return (
      <div style={{ position: 'absolute', zIndex: 2, top: 70, left: 10 }}>
        <BlockPicker color={bgColor} colors={['#ffeb3b', '#f44336', '#03a9f4', '#4caf50']} onChangeComplete={onChangeModal} />
      </div>
    );
  };

  const { expanded, onExpandEvent } = props;
  return (
    <div
      aria-haspopup="true"
      aria-expanded={expanded}
      aria-label="rdw-color-picker"
      style={{ display: 'flex', flexDirection: 'row', marginLeft: 'auto' }}
    >
      <div
        onClick={onExpandEvent}
        style={{ border: '1px solid', padding: 5, cursor: "pointer" }}
      >
        <strong>Marcar Texto</strong>
      </div>
      <div
        onClick={() => { onChange('bgcolor', 'unset'); }}
        style={{ border: '1px solid', padding: 5, marginLeft: 10, cursor: "pointer" }}
      >
        <strong>Remover Marcação</strong>
      </div>
      {expanded ? renderModal() : undefined}
    </div>
  );
}



function HighlightModal(props) {
  const [content, setContent] = useState()
  const [isNew, setIsNew] = useState(true)
  const [userContentId, setUserContentId] = useState('')
  const { auth, dispatch } = useContext(AuthContext)
  useEffect(() => {
    api.get(`/userEmphasize/${props.content._id}`).then(res => {
      if (res.userEmphasize) {
        setIsNew(false)
        setUserContentId(res.userEmphasize._id);
        const contentBlock = htmlToDraft(res.userEmphasize.htmlContent);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        setContent(editorState)
      } else {
        const contentBlock = htmlToDraft(props.content.htmlContent);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        setContent(editorState)
      }
    }, [])
  }, [])

  const onEditorStateChange = (editorState) => {
    setContent(editorState)
  };

  const handleBeforeInput = () => {
    return 'delete-me'
  }

  const handleFinish = () => {
    const finishState = draftToHtml(convertToRaw(content.getCurrentContent()))
    if (isNew) {
      api.post('/userEmphasize', { content: props.content._id, student: auth.user._id, htmlContent: finishState }).then(res => {
        if (res.userEmphasize) {
          toast.success("Texto marcado com sucesso!")
          props.toggle(props.content);
        }
      }).catch(err => {
        console.log(err)
        toast.error("Ops, algo deu errado!")
      })
    } else {
      api.put(`/userEmphasize/${userContentId}`, { htmlContent: finishState }).then(res => {
        if (res.userEmphasize) {
          toast.success("Texto marcado com sucesso!")
          props.toggle(props.content);
        }
      }).catch(err => {
        toast.error("Ops, algo deu errado!")
      })
    }
  }

  return (
    <>
      <ModalHeader toggle={props.toggle}>{props.content.name}</ModalHeader>
      <ModalBody>
        <div>
          <Editor
            editorState={content}
            onEditorStateChange={onEditorStateChange}
            keyBindingFn={handleBeforeInput}
            editorStyle={{ color: "#000" }}
            toolbar={{
              options: ['colorPicker'],
              colorPicker: { component: ColorOption },
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleFinish}>Salvar</Button>{' '}
        <Button color="secondary" onClick={props.toggle}>Fechar</Button>
      </ModalFooter>
    </>
  );
}

export default HighlightModal;